import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';

import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import moment from 'moment';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { FlatButton } from 'material-ui';



//  serial_number_dib={machine.serial_number_dib}</li>

let pageStyle = {
  margin:"1em",
};
let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}
export default
@observer class MachineHistory extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  createRow(change){

    return (
      <TableRow key={change.startdate+change.customer}>
        <TableRowColumn>{moment(change.startdate).format('YYYY-MM-DD HH:mm')}</TableRowColumn>
        <TableRowColumn>{change.enddate ? moment(change.enddate).format('YYYY-MM-DD HH:mm') : "—"}</TableRowColumn>
        <TableRowColumn>{change.customer}</TableRowColumn>
      </TableRow>
    )
  }


  render() {
    let machine = AppModel.currentMachine;

    return (
      <div style={pageStyle}>
        <PageLoading loading={AppModel.fetchingMachineDetails}>
          <h2 style={headerStyle}>{machine.id}</h2>
          <Table>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn>{uiMsg('MHP_START_DATE', "Start date")}</TableHeaderColumn>
                <TableHeaderColumn>{uiMsg('MHP_END_DATE', "End date")}</TableHeaderColumn>
                <TableHeaderColumn>{uiMsg('MHP_CUSTOMER', "Customer")}</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {AppModel.fetchingMachineDetails ? null : machine.history.map(this.createRow)}
            </TableBody>
          </Table>
          <div style={{height:"1em"}}></div>

        </PageLoading>
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/MachineHistoryPage.jsx
 **/